// extracted by mini-css-extract-plugin
export var container = "ClientList-module--container--984d0";
export var m2Xl = "ClientList-module--m-2xl--d0c54";
export var m2Xs = "ClientList-module--m-2xs--01ad1";
export var m3Xl = "ClientList-module--m-3xl--666fe";
export var m3Xs = "ClientList-module--m-3xs--2afc1";
export var m4Xl = "ClientList-module--m-4xl--aca6e";
export var m5Xl = "ClientList-module--m-5xl--e2c80";
export var m6Xl = "ClientList-module--m-6xl--217a6";
export var m7Xl = "ClientList-module--m-7xl--d4d86";
export var m8Xl = "ClientList-module--m-8xl--92724";
export var mBase = "ClientList-module--m-base--bc96e";
export var mLg = "ClientList-module--m-lg--59e68";
export var mMd = "ClientList-module--m-md--96eb7";
export var mSm = "ClientList-module--m-sm--507a4";
export var mXl = "ClientList-module--m-xl--dc661";
export var mXs = "ClientList-module--m-xs--4603c";
export var mb2Xl = "ClientList-module--mb-2xl--86498";
export var mb2Xs = "ClientList-module--mb-2xs--5145d";
export var mb3Xl = "ClientList-module--mb-3xl--54066";
export var mb3Xs = "ClientList-module--mb-3xs--fa06d";
export var mb4Xl = "ClientList-module--mb-4xl--482d0";
export var mb5Xl = "ClientList-module--mb-5xl--16722";
export var mb6Xl = "ClientList-module--mb-6xl--bd812";
export var mb7Xl = "ClientList-module--mb-7xl--9c422";
export var mb8Xl = "ClientList-module--mb-8xl--2bce6";
export var mbBase = "ClientList-module--mb-base--bfe64";
export var mbLg = "ClientList-module--mb-lg--8aabe";
export var mbMd = "ClientList-module--mb-md--68ce1";
export var mbSm = "ClientList-module--mb-sm--ccc23";
export var mbXl = "ClientList-module--mb-xl--54fe7";
export var mbXs = "ClientList-module--mb-xs--015ea";
export var ml2Xl = "ClientList-module--ml-2xl--858db";
export var ml2Xs = "ClientList-module--ml-2xs--47c69";
export var ml3Xl = "ClientList-module--ml-3xl--6e30d";
export var ml3Xs = "ClientList-module--ml-3xs--ecbf5";
export var ml4Xl = "ClientList-module--ml-4xl--5c441";
export var ml5Xl = "ClientList-module--ml-5xl--71740";
export var ml6Xl = "ClientList-module--ml-6xl--6c1d9";
export var ml7Xl = "ClientList-module--ml-7xl--d843d";
export var ml8Xl = "ClientList-module--ml-8xl--e76ec";
export var mlBase = "ClientList-module--ml-base--2b39b";
export var mlLg = "ClientList-module--ml-lg--28175";
export var mlMd = "ClientList-module--ml-md--89d6b";
export var mlSm = "ClientList-module--ml-sm--6caf2";
export var mlXl = "ClientList-module--ml-xl--556b7";
export var mlXs = "ClientList-module--ml-xs--dc782";
export var mr2Xl = "ClientList-module--mr-2xl--fefa4";
export var mr2Xs = "ClientList-module--mr-2xs--6eb45";
export var mr3Xl = "ClientList-module--mr-3xl--8069c";
export var mr3Xs = "ClientList-module--mr-3xs--312d2";
export var mr4Xl = "ClientList-module--mr-4xl--8ef90";
export var mr5Xl = "ClientList-module--mr-5xl--79863";
export var mr6Xl = "ClientList-module--mr-6xl--277e1";
export var mr7Xl = "ClientList-module--mr-7xl--1a919";
export var mr8Xl = "ClientList-module--mr-8xl--3ae68";
export var mrBase = "ClientList-module--mr-base--3f78b";
export var mrLg = "ClientList-module--mr-lg--0f114";
export var mrMd = "ClientList-module--mr-md--9cd26";
export var mrSm = "ClientList-module--mr-sm--c57bd";
export var mrXl = "ClientList-module--mr-xl--b6b7e";
export var mrXs = "ClientList-module--mr-xs--2dd71";
export var mt2Xl = "ClientList-module--mt-2xl--2b44f";
export var mt2Xs = "ClientList-module--mt-2xs--6f581";
export var mt3Xl = "ClientList-module--mt-3xl--00c3d";
export var mt3Xs = "ClientList-module--mt-3xs--2ec7e";
export var mt4Xl = "ClientList-module--mt-4xl--a37f6";
export var mt5Xl = "ClientList-module--mt-5xl--dd592";
export var mt6Xl = "ClientList-module--mt-6xl--dbd30";
export var mt7Xl = "ClientList-module--mt-7xl--d6892";
export var mt8Xl = "ClientList-module--mt-8xl--f267a";
export var mtBase = "ClientList-module--mt-base--0b7ea";
export var mtLg = "ClientList-module--mt-lg--17866";
export var mtMd = "ClientList-module--mt-md--35f7c";
export var mtSm = "ClientList-module--mt-sm--33a4a";
export var mtXl = "ClientList-module--mt-xl--6f767";
export var mtXs = "ClientList-module--mt-xs--8dc2c";
export var p2Xl = "ClientList-module--p-2xl--07579";
export var p2Xs = "ClientList-module--p-2xs--c3f38";
export var p3Xl = "ClientList-module--p-3xl--dab1b";
export var p3Xs = "ClientList-module--p-3xs--2aba4";
export var p4Xl = "ClientList-module--p-4xl--9ae56";
export var p5Xl = "ClientList-module--p-5xl--9264a";
export var p6Xl = "ClientList-module--p-6xl--11548";
export var p7Xl = "ClientList-module--p-7xl--f6514";
export var p8Xl = "ClientList-module--p-8xl--e2a78";
export var pBase = "ClientList-module--p-base--933ec";
export var pLg = "ClientList-module--p-lg--12ca1";
export var pMd = "ClientList-module--p-md--16acc";
export var pSm = "ClientList-module--p-sm--11019";
export var pXl = "ClientList-module--p-xl--ce499";
export var pXs = "ClientList-module--p-xs--6cc7a";
export var pb2Xl = "ClientList-module--pb-2xl--1d29d";
export var pb2Xs = "ClientList-module--pb-2xs--aae0c";
export var pb3Xl = "ClientList-module--pb-3xl--d11a1";
export var pb3Xs = "ClientList-module--pb-3xs--52dec";
export var pb4Xl = "ClientList-module--pb-4xl--64381";
export var pb5Xl = "ClientList-module--pb-5xl--4b228";
export var pb6Xl = "ClientList-module--pb-6xl--0d673";
export var pb7Xl = "ClientList-module--pb-7xl--2e0d2";
export var pb8Xl = "ClientList-module--pb-8xl--d88f9";
export var pbBase = "ClientList-module--pb-base--e06fd";
export var pbLg = "ClientList-module--pb-lg--fbc07";
export var pbMd = "ClientList-module--pb-md--fcb97";
export var pbSm = "ClientList-module--pb-sm--31fcd";
export var pbXl = "ClientList-module--pb-xl--3da98";
export var pbXs = "ClientList-module--pb-xs--0ac13";
export var pl2Xl = "ClientList-module--pl-2xl--9351c";
export var pl2Xs = "ClientList-module--pl-2xs--cad2d";
export var pl3Xl = "ClientList-module--pl-3xl--5408d";
export var pl3Xs = "ClientList-module--pl-3xs--68d52";
export var pl4Xl = "ClientList-module--pl-4xl--dd022";
export var pl5Xl = "ClientList-module--pl-5xl--4ea41";
export var pl6Xl = "ClientList-module--pl-6xl--4f696";
export var pl7Xl = "ClientList-module--pl-7xl--7265d";
export var pl8Xl = "ClientList-module--pl-8xl--cee87";
export var plBase = "ClientList-module--pl-base--99e3d";
export var plLg = "ClientList-module--pl-lg--32cf5";
export var plMd = "ClientList-module--pl-md--ca41a";
export var plSm = "ClientList-module--pl-sm--edd0e";
export var plXl = "ClientList-module--pl-xl--3d0ac";
export var plXs = "ClientList-module--pl-xs--f700f";
export var pr2Xl = "ClientList-module--pr-2xl--4bf33";
export var pr2Xs = "ClientList-module--pr-2xs--19f94";
export var pr3Xl = "ClientList-module--pr-3xl--7f2da";
export var pr3Xs = "ClientList-module--pr-3xs--54118";
export var pr4Xl = "ClientList-module--pr-4xl--c1a46";
export var pr5Xl = "ClientList-module--pr-5xl--81e0c";
export var pr6Xl = "ClientList-module--pr-6xl--6154b";
export var pr7Xl = "ClientList-module--pr-7xl--f63a8";
export var pr8Xl = "ClientList-module--pr-8xl--692bd";
export var prBase = "ClientList-module--pr-base--80a0a";
export var prLg = "ClientList-module--pr-lg--ad3a0";
export var prMd = "ClientList-module--pr-md--2f467";
export var prSm = "ClientList-module--pr-sm--01115";
export var prXl = "ClientList-module--pr-xl--0b196";
export var prXs = "ClientList-module--pr-xs--852d2";
export var pt2Xl = "ClientList-module--pt-2xl--bf27d";
export var pt2Xs = "ClientList-module--pt-2xs--d41d5";
export var pt3Xl = "ClientList-module--pt-3xl--8299f";
export var pt3Xs = "ClientList-module--pt-3xs--6a78f";
export var pt4Xl = "ClientList-module--pt-4xl--9a88c";
export var pt5Xl = "ClientList-module--pt-5xl--f2130";
export var pt6Xl = "ClientList-module--pt-6xl--9666d";
export var pt7Xl = "ClientList-module--pt-7xl--47051";
export var pt8Xl = "ClientList-module--pt-8xl--bea50";
export var ptBase = "ClientList-module--pt-base--11c51";
export var ptLg = "ClientList-module--pt-lg--8f8e1";
export var ptMd = "ClientList-module--pt-md--db024";
export var ptSm = "ClientList-module--pt-sm--6be89";
export var ptXl = "ClientList-module--pt-xl--65914";
export var ptXs = "ClientList-module--pt-xs--b777e";